import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VAlert,{staticClass:"rounded-card",attrs:{"color":"warning","outlined":"","dismissible":""}},[_c('span',[_vm._v("NÃO COBRAMOS COMISSÕES EM COTAÇÕES!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }